import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import Sidebar from 'shared/sidebar';
import { Loader } from '@here/ref-client-ui';

import './styles/filterPanelContainer.scss';
import { getTitle } from 'state/tabs/tab/title';
import { getIsLoading } from 'state/tabs/tab/isLoading';
import {getIsLeftPanelShown,getIsResultPanelShown} from '../../state/ui';
import { setIsLeftPanelShown} from '../../state/ui/reducer';
import classnames from 'classnames';
import formViewsPlugin from '../../core/formViewsPlugin';
import { getFields, setFields } from '../../state/tabs/tab/fields/reducer';
import { getConfig } from '../../state/config';
import { set as setNotification } from 'state/notification/actions';
import { getTabSettings, setPreset } from '../../state/tabs/tab/preset/reducer';
import { getID } from '../../state/tabs/tab/id';
import { setResultState } from '../../state/tabs/tab/result/state/reducer';
import FormViewErrorHandler from './FormViewErrorHandler';
import refClient from '../../core/refClient';
import { fetchData, getFieldsRequestOptions, rawRequest, rawRequestWithAuth } from '../../state/tabs/tab/response/actions';
import { setSelectedCountry } from '../../state/selectedCountry/actions';
import { getSelectedCountry } from '../../state/selectedCountry';  
import { parseGlobalRulesFromApi,parseODRulesFromApi } from '../../utils/api/countryrules/helperTransformer';
import {getActiveUserInfo} from '../../state/selectedUser/index';
import {getSupportedCountries } from '../../state/countries/index';

import {
  getTabParamsMapping,
  setTabParamsMapping,
} from '../../state/tabs/tab/paramsMapping/reducer';
import ParamsMapping from './ParamsMapping';
import adjustLUIStyle from '../../utils/adjustLUIStyle';
import CountryFilter from './CountryFilter';
import { setSelectedForm } from '../../state/tabs/tab/selectedForm/actions';
import { getSelectedForm } from '../../state/tabs/tab/selectedForm';
import RulesForm from './RulesForm';
import { segregateByCategory } from './inputsSegregator';
import { FORM_TYPES } from '../../state/tabs/tab/selectedForm/constants';
import {submitGlobalCountryRules,fetchCountryRules, submitODCountryRules, createCountryRules, deleteODCountryRules, fetchSupportedCountries} from '../../utils/api/countryrules/countryrules';
import { v4 as uuidv4 } from 'uuid';
import axios from 'axios';
import { SELECTEDTAB_INDEX } from '../../state/selectedTab/constants';
import { getSelectedTabs } from '../../state/tabs';
import { getAppSettings } from '../../state/appSettings';
import RulesFormDropdown from './RulesFormDropdown';
import { isEqual, cloneDeep } from 'lodash';
import { setRawResult } from '../../state/tabs/tab/result/raw/reducer';
import { setSupportedCountries } from '../../state/countries/actions';

export class FilterPanelContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingRules: false,
      isSubmittingRules: false,
      cancelTokenSource: null,
      countryRules: {},
      odId: null,
      isChanged: false,
      hasValidationErrors: false,
      isNewOdRule: false,
      validationMessage: '',
      formTypeOptions: [{
        value: FORM_TYPES.GLOBAL,
        label: 'Global'
      }]
    };
  }

  componentDidMount() {
    adjustLUIStyle(document.querySelectorAll('.rf-filter-panel_bottom_btns lui-button'), 'lui-button');
    if ('token' in this.props.settings && this.props.supportedCountries.length === 0) {
          this.loadCountries();
    }
  }

  componentDidUpdate(prevProps, prevState) {

    if ('token' in this.props.settings && this.props.supportedCountries.length === 0) {
          this.loadCountries();
    }
    if(prevProps.selectedCountry !== this.props.selectedCountry) {
      if(this.props.selectedCountry && this.props.selectedCountry.length > 0){
        this.loadCountryRules();
      }
    }

    const isOriginDestinationInpChanged = prevProps.fields?.origin !== this.props.fields?.origin ||
      prevProps.fields?.destination !== this.props.fields?.destination;
    
    if(isOriginDestinationInpChanged){
      this.props.setRawResult(null, SELECTEDTAB_INDEX);
    }

    // Auto-generate name when origin or destination changes for OD rules
    if (this.props.selectedForm !== FORM_TYPES.GLOBAL && isOriginDestinationInpChanged) {
      const currentName = this.props.fields?.odRuleName || '';
      // Only auto-generate if name is empty or matches the auto-generated pattern
      const autoGenerated = this.generateRuleNameFromCoordinates(prevProps.fields?.origin, prevProps.fields?.destination);
      if (!currentName || currentName === autoGenerated) {
        const newName = this.generateRuleNameFromCoordinates(this.props.fields?.origin, this.props.fields?.destination);
        if (newName && newName !== currentName) {
          this.props.setFields({ 'odRuleName': newName }, 0);
        }
      }
    }

    this.checkIfRulesModified(prevProps, prevState);
  }

  checkIfRulesModified = (prevProps, prevState) => {
    // Reset flags when rules are saved or loaded
    if (prevState.isLoadingRules && !this.state.isLoadingRules) {
      this.setState({ isChanged: false, hasValidationErrors: false, validationMessage: '' });
    }
    if (prevState.isSubmittingRules && !this.state.isSubmittingRules) {
      this.setState({ isChanged: false, hasValidationErrors: false, validationMessage: '' });
    }

    if(this.props.selectedCountry && !this.state.countryRules[this.props.selectedCountry] && !this.state.isNewOdRule){
    // For countries without existing rules, check if any fields have non-default values
    const { fields } = this.props;
    const hasFieldData = (fields['avoid[features]'] && fields['avoid[features]'].values && fields['avoid[features]'].values.length > 0) ||
                         (fields.avoid && fields.avoid.areas && fields.avoid.areas.length > 0) ||
                         (fields['vehicle[speedCapPerFc]'] && fields['vehicle[speedCapPerFc]'] !== '') ||
                         (fields.exclude && fields.exclude.areas && fields.exclude.areas.length > 0);
    
    // For OD rules, also check origin, destination, and rule name
    let hasODFieldData = false;
    if (this.props.selectedForm !== FORM_TYPES.GLOBAL) {
      hasODFieldData = (fields.origin && fields.origin.trim() !== '') ||
                       (fields.destination && fields.destination.trim() !== '') ||
                       (fields.odRuleName && fields.odRuleName.trim() !== '') ||
                       (fields.via && fields.via.length > 0);
    }
    
    const hasAnyFieldData = hasFieldData || hasODFieldData;
    
    // Only update state if values have actually changed
    if (hasAnyFieldData !== this.state.isChanged || 
        this.state.hasValidationErrors !== false || 
        this.state.validationMessage !== (hasAnyFieldData ? 'New changes detected' : '')) {
          
      this.setState({ 
        isChanged: hasAnyFieldData, 
        hasValidationErrors: false, 
        validationMessage: hasAnyFieldData ? 'New changes detected' : '' 
      });
    }
    return;
  }

    // Monitor changes in country rules related fields
    const fieldsToMonitor = [
      'avoid[features]',
      'avoid',
      'vehicle[speedCapPerFc]',
      'exclude',
      'origin',
      'destination',
      'via',
      'odRuleName'
    ];
    const hasFieldsChanged = fieldsToMonitor.some(field => 
      !isEqual(prevProps.fields[field], this.props.fields[field])
    );
    
    if (hasFieldsChanged && this.props.selectedCountry) {
      const { selectedCountry, selectedForm, fields } = this.props;
      const { countryRules, isNewOdRule } = this.state;
      const currentCountryRules = countryRules[selectedCountry];
      
      let hasChangesFromRules = false;
      let hasValidationErrors = false;
      let validationMessage = '';
      
      // Validation logic for all OD rules (new and existing)
      if (selectedForm !== FORM_TYPES.GLOBAL) {
        const hasOrigin = fields.origin && fields.origin.trim() !== '';
        const hasDestination = fields.destination && fields.destination.trim() !== '';
        const hasRuleName = fields.odRuleName && fields.odRuleName.trim() !== '';
        
        hasValidationErrors = !hasOrigin || !hasDestination || !hasRuleName;
        
        if (hasValidationErrors) {
          const missingFields = [];
          if (!hasOrigin) missingFields.push('origin');
          if (!hasDestination) missingFields.push('destination');
          if (!hasRuleName) missingFields.push('rule name');
          validationMessage = `Required fields missing: ${missingFields.join(', ')}`;
        }
      }

      // Change detection logic
      if (selectedForm === FORM_TYPES.GLOBAL && currentCountryRules?.globalRules) {
        const { avoidFeatures, avoid, vehicleSpeedCap, exclude } = parseGlobalRulesFromApi(currentCountryRules);
        hasChangesFromRules = !isEqual(fields['avoid[features]'], avoidFeatures) ||
                              !isEqual(fields.avoid, avoid) ||
                              !isEqual(fields['vehicle[speedCapPerFc]'], vehicleSpeedCap) ||
                              !isEqual(fields.exclude, exclude);
        
        if (hasChangesFromRules) {
          validationMessage = 'Changes detected from saved rule';
        }
      } else if (selectedForm !== FORM_TYPES.GLOBAL && !isNewOdRule) {
        // Only compare with saved rules for existing OD rules
        if (!hasValidationErrors && currentCountryRules?.originDestinationRules) {
          const matchedRule = currentCountryRules.originDestinationRules[this.state.odId];
          
          if (matchedRule) {
            const { avoidFeatures, avoid, vehicleSpeedCap, exclude, origin, destination, viaPoints } = parseODRulesFromApi(matchedRule);
            hasChangesFromRules = !isEqual(fields['avoid[features]'], avoidFeatures) ||
                                  !isEqual(fields.avoid, avoid) ||
                                  !isEqual(fields['vehicle[speedCapPerFc]'], vehicleSpeedCap) ||
                                  !isEqual(fields.exclude, exclude) ||
                                  !isEqual(fields.origin, origin) ||
                                  !isEqual(fields.destination, destination) ||
                                  !isEqual(fields.via, viaPoints) ||
                                  !isEqual(fields.odRuleName, matchedRule.name);
            
            if (hasChangesFromRules) {
              validationMessage = 'Changes detected from saved rule';
            }
          }
        }
      }
      // For new OD rules, hasChangesFromRules stays false (no saved state to compare)

      if (hasChangesFromRules !== this.state.isChanged || 
          hasValidationErrors !== this.state.hasValidationErrors || 
          validationMessage !== this.state.validationMessage) {
        this.setState({ 
          isChanged: hasChangesFromRules, 
          hasValidationErrors, 
          validationMessage 
        });
      }
    }
  }
 
  generateRuleNameFromCoordinates = (origin, destination) => {
    if (!origin || !destination) return '';
    const originCoords = origin.split(',');
    const destinationCoords = destination.split(',');
    if (originCoords.length === 2 && destinationCoords.length === 2) {
      const originStr = `${parseFloat(originCoords[0]).toFixed(3)},${parseFloat(originCoords[1]).toFixed(3)}`;
      const destinationStr = `${parseFloat(destinationCoords[0]).toFixed(3)},${parseFloat(destinationCoords[1]).toFixed(3)}`;
      return `${originStr} to ${destinationStr}`;
    }
    return '';
  }

  setFormType = (formType) => {
    this.props.setSelectedForm(formType);
  }

  onRuleFormChange = (e) => {
    const value = e.target.value;
    this.props.setSelectedForm(value);
    if(value === FORM_TYPES.GLOBAL){
      this.setState({ 
        odId: null, 
        isNewOdRule: false, 
        isChanged: false, 
        hasValidationErrors: false, 
        validationMessage: '' 
      }, () =>{
        if(this.state.countryRules){
          this.loadFormSpecificCountryRules(value);
        }
      });
    } else {
      // Check if this is a new OD rule (UUID) or existing rule ID
      const isNewRule = value.length === 36 && value.includes('-'); // UUID format check
      this.setState({ 
        odId: value, 
        isNewOdRule: isNewRule, 
        isChanged: false, 
        hasValidationErrors: false, 
        validationMessage: '' 
      }, () =>{
        if(this.state.countryRules){
          this.loadFormSpecificCountryRules(value);
        }
      });
    }
  };

  createInputs = (inputs) => {
    const { 
      tabId,
      selectedForm,
      fields,
      setFields,
      setNotification,
      settings,
      setResultState,
      request,
      setPreset } = this.props;
    
    return inputs.map((input, index) => {
      const { type, options } = input;
      const key = `${type}${tabId}${index}${selectedForm || ''}`;
      try {
        const { Component } = formViewsPlugin.get(type);

        return  <FormViewErrorHandler key={key} inputConfig={input}>
            <Component
              fields={fields}
              setFields={setFields}
              options={options}
              setNotification={setNotification}
              settings={settings}
              setResultState={setResultState}
              refClient={refClient}
              request={request}
              setPreset={setPreset}
            />
          </FormViewErrorHandler>;
          
      } catch (e) {
        return <FormViewErrorHandler key={key} inputConfig={input} error={e} />;
      }
    });    
  }

  resetFields= () => {
    // Clone current nested objects to avoid mutating props.fields directly
    const avoidFeatures = cloneDeep(this.props.fields['avoid[features]']);
    const avoid = cloneDeep(this.props.fields.avoid);
    const exclude = cloneDeep(this.props.fields.exclude);

    // Clear arrays on cloned objects
    if (avoidFeatures && Array.isArray(avoidFeatures.values)) {
      avoidFeatures.values = [];
    }
    if (avoid && Array.isArray(avoid.areas)) {
      avoid.areas = [];
    }
    if (exclude && Array.isArray(exclude.areas)) {
      exclude.areas = [];
    }

    const fields = {
      avoid,
      'avoid[features]': avoidFeatures,
      'vehicle[speedCapPerFc]': '',
      exclude,
      odRuleName: '',
      origin: '',
      destination: '',
      via: [],
      preferMainRoads: false
    };
    this.props.setFields(fields,0);
  }
  
  toggleVisibility = () => {
    this.props.setIsLeftPanelShown(!this.props.isLeftPanelShown);
  };

  loadCountries = async () => {

    try{
      let supportedCountries = await fetchSupportedCountries(this.props.settings)
      if(supportedCountries && supportedCountries.data){
        if(['dev-sk','prd-sk'].includes(process.env.REACT_APP_ENV)) {
          const southKorea = supportedCountries.data.find(country => country.code === 'KOR');
          this.props.setSupportedCountries([southKorea]);
          return;
        }
        const filteredCountries = supportedCountries.data.filter(country => country.code !== 'KOR');
        this.props.setSupportedCountries(filteredCountries);
      }
    }
    catch (error) { 
      this.props.setNotification({
        message: `Failed to fetch supported countries: ${error.message}`,
        impact: 'negative',
        autoDismiss: 5,
      });
    }
  }

  loadCountryRules = async () => {
    const { selectedCountry } = this.props;
    if(selectedCountry !==  ""){
      this.setState({ isLoadingRules: true });
        try {
          let rules = await fetchCountryRules(this.props.settings, selectedCountry)
          if( rules !== undefined && rules !== null && (rules.status === 'success' || rules.status === 200) ){
            const {globalRules, originDestinationRules = {} } =  rules.data

            let odPairs = Object.entries(originDestinationRules).map(([key, rule]) => {
              return {
                "value": key,
                "label": rule.name || `OD Rule ${key}`
              }
            });
            
            odPairs = [{"value": FORM_TYPES.GLOBAL, "label": "Global"}, ...odPairs ];
            
            this.setState({ formTypeOptions :odPairs });

            const countryRules = {
              [selectedCountry]: {
                globalRules: cloneDeep(globalRules),
                originDestinationRules: cloneDeep(originDestinationRules || {})
              }
            };
            
            this.setState({ countryRules }, () => {
              if(this.props.selectedForm !== FORM_TYPES.GLOBAL && originDestinationRules[this.props.selectedForm]){
                this.loadFormSpecificCountryRules(this.props.selectedForm)
              } else {
                this.loadFormSpecificCountryRules(FORM_TYPES.GLOBAL)
              }
            });
          }
          else{
            this.props.setNotification({
              message: `No rules found for ${selectedCountry}.`,
              impact: 'Positive',
            });
          }
        } catch (error) {
          this.props.setNotification({
            message: `Failed to load rules for ${selectedCountry}: ${error.message}`,
            impact: 'negative',
            autoDismiss: 5,
          });
        } finally {
          this.setState({ isLoadingRules: false });
        } 
    }
  }

  loadFormSpecificCountryRules = async (formType) =>{   
    const {selectedCountry } = this.props;
    const { countryRules: countryRulesState, odId } = this.state;

    if(!countryRulesState[selectedCountry]) return; 

    // Initialize all fields with default/cleared values
    const { avoid, 'avoid[features]': avoidFeatures, exclude } = this.props.fields;
    const defaultFields = {
      'avoid[features]': { ...avoidFeatures, values: [] },
      avoid: { ...avoid, areas: [] },
      'vehicle[speedCapPerFc]': '',
      exclude: { ...exclude, areas: [] },
      origin: '',
      destination: '',
      via: [],
      odRuleName: '',
      preferMainRoads: false
    };

    if(formType === FORM_TYPES.GLOBAL){
      const { avoidFeatures, avoid, vehicleSpeedCap, exclude } = parseGlobalRulesFromApi(countryRulesState[selectedCountry]);
      this.props.setFields({ 
        ...defaultFields, // Clear OD-specific fields
        'avoid[features]': cloneDeep(avoidFeatures),
        avoid: cloneDeep(avoid),
        'vehicle[speedCapPerFc]': vehicleSpeedCap, 
        exclude: cloneDeep(exclude) 
      }, 0);
      this.setState({ isNewOdRule: false, isChanged: false, hasValidationErrors: false, validationMessage: '' });
    } else {
      const { originDestinationRules = {} } = countryRulesState[selectedCountry];
      if(originDestinationRules[odId]){  
        const { avoidFeatures,
          avoid,
          vehicleSpeedCap,
          exclude,
          origin,
          destination,
          viaPoints,
          odRuleName } = parseODRulesFromApi(originDestinationRules[odId]);
        // Auto-generate name if empty
        const finalName = odRuleName || this.generateRuleNameFromCoordinates(origin, destination);
        this.props.setFields({ 
          ...defaultFields, // Reset all to defaults first
          'avoid[features]': cloneDeep(avoidFeatures),
          avoid: cloneDeep(avoid),
          'vehicle[speedCapPerFc]': vehicleSpeedCap,
          exclude: cloneDeep(exclude),
          'origin': origin,
          'destination': destination,
          'via': cloneDeep(viaPoints),
          'odRuleName': finalName 
        }, 0);
        this.setState({ isNewOdRule: false, isChanged: false, hasValidationErrors: false, validationMessage: '' });
      } else {
        // This handles new OD rules that don't exist in originDestinationRules yet - clear all fields
        this.props.setFields(defaultFields, 0);
        this.setState({ 
          isNewOdRule: true, 
          isChanged: false, 
          hasValidationErrors: true, 
          validationMessage: 'Required fields missing: origin, destination, rule name' 
        });
      }
    }
  }


  setCountry = async (value) => {
    this.props.setSelectedCountry(value);
    
    if(!value){
      this.resetFields();
      if( this.props.selectedCountry !==  ""){
        let countryRulesState = { ...this.state.countryRules };
        delete countryRulesState[this.props.selectedCountry];
        this.setState({ countryRules: countryRulesState });
      }
    }
  }

  hasInvalidRadius = (areas) => {
    return areas.some(area => {
      if ((area.type === "corridor" || area.type === "encodedCorridor" || area.type === "exceptionCorridor" || area.type === "encodedExceptionCorridor")) {
        return !area.radius || isNaN(parseFloat(area.radius)) || parseFloat(area.radius) <= 0;
      }
      return false;
    });
  }

  hasInvalidArea = (areas) => {
    const invalidAreaIdx = areas.findIndex(area => {
      const { geometry } = area;
      if (!geometry || !Array.isArray(geometry)) return true;
      return geometry
        .some(point => !Array.isArray(point)
          || point.length === 0 
          || !point[0] 
          || !point[1]
        );
    });
    
    return invalidAreaIdx !== -1;
  }

  submitCountryRules = async () => {
    const { avoid, exclude } = this.props.fields;

    if (this.hasInvalidArea(avoid.areas) 
      || this.hasInvalidArea(exclude.areas)) {
      this.props.setNotification({
        message: `Cannot submit country rules. One or more areas have an invalid geometry.`,
        impact: 'negative',
        autoDismiss: 10,
      });
      return;
    }

    if (this.hasInvalidRadius(avoid.areas) 
      || this.hasInvalidRadius(exclude.areas)) {
      this.props.setNotification({
        message: `Cannot submit country rules. One or more corridor areas have an invalid radius.`,
        impact: 'negative',
        autoDismiss: 10,
      });
      return;
    }

    // Validate that all avoid/exclude areas have a non-empty name
    const allAreas = [...(avoid.areas || []), ...(exclude.areas || [])];
    const hasEmptyName = allAreas.some(area => {
      const name = (area && area.name) ? String(area.name).trim() : '';
      return !name;
    });

    if (hasEmptyName) {
      this.props.setNotification({
        message: `Cannot submit country rules. Area name is required for all shapes.`,
        impact: 'negative',
        autoDismiss: 10,
      });
      return;
    }
    
  this.setState({ isSubmittingRules: true });
    
    try {
      let res;
      if(Object.values(this.state.countryRules).length === 0){
          res = await createCountryRules(
            this.props.fields,
            this.props.selectedCountry,
            this.props.selectedForm,
            this.props.settings,
            this.state.odId
          );
      } else {
        if(this.props.selectedForm === FORM_TYPES.GLOBAL){
          res = await submitGlobalCountryRules(this.props.fields, this.props.selectedCountry, this.props.settings);
        } else {
          res = await submitODCountryRules(
            this.props.fields,
            this.props.selectedCountry,
            this.props.settings,
            this.state.odId
          );
        }
      }
      
      if(res && (res.status === 'success' || res.status === 200 || res.status === 201)){

        this.loadCountryRules();
        this.props.setNotification({
          message: `Country rules for ${this.props.selectedCountry} submitted successfully.`,
          impact: 'positive',
          autoDismiss: 2,
        });
      }
    } catch (error) {            
      this.props.setNotification({
        message: `Failed to submit country rules: ${error.message}`,
        impact: 'negative',
        autoDismiss: 5,
      });
    } finally {
      this.setState({ isSubmittingRules: false });
    }
  }

  resetInputs = () => {
    const { selectedCountry, selectedForm } = this.props;
    const { countryRules, isNewOdRule } = this.state;
    
    // Initialize all fields with default/cleared values
    const { avoid, 'avoid[features]': avoidFeatures, exclude } = this.props.fields;
    const defaultFields = {
      'avoid[features]': { ...avoidFeatures, values: [] },
      avoid: { ...avoid, areas: [] },
      'vehicle[speedCapPerFc]': '',
      exclude: { ...exclude, areas: [] },
      origin: '',
      destination: '',
      via: [],
      odRuleName: '',
      preferMainRoads: false
    };

    if (selectedForm === FORM_TYPES.GLOBAL) {
      // For GLOBAL form - load global rules or clear all fields
      if (selectedCountry !== "" && countryRules[selectedCountry]?.globalRules) {
        const { avoidFeatures, avoid, vehicleSpeedCap, exclude } = parseGlobalRulesFromApi(
          countryRules[selectedCountry]
        );
        
        this.props.setFields({
          ...defaultFields, // Clear OD-specific fields
          'avoid[features]': cloneDeep(avoidFeatures),
            avoid: cloneDeep(avoid),
            'vehicle[speedCapPerFc]': vehicleSpeedCap,
            exclude: cloneDeep(exclude)
        }, 0);
      } else {
        // No global rules exist - clear everything
        this.props.setFields(defaultFields, 0);
      }
    } else {
      // For OD form - load specific OD rule or reset to new OD state
      if (
        selectedCountry !== "" &&
        !isNewOdRule &&
        countryRules[selectedCountry]?.originDestinationRules
      ) {
        const odRule = countryRules[selectedCountry].originDestinationRules[selectedForm];
        
        if (odRule) {
          const { 
            avoidFeatures, 
            avoid, 
            vehicleSpeedCap, 
            exclude, 
            origin, 
            destination, 
            viaPoints, 
            odRuleName 
          } = parseODRulesFromApi(odRule);
          
          // Auto-generate name if empty
          const finalName = odRuleName || this.generateRuleNameFromCoordinates(origin, destination);
          
          this.props.setFields({
            ...defaultFields, // Reset all to defaults first
            'avoid[features]': cloneDeep(avoidFeatures),
            avoid: cloneDeep(avoid),
            'vehicle[speedCapPerFc]': vehicleSpeedCap,
            exclude: cloneDeep(exclude),
            'origin': origin,
            'destination': destination,
            'via': cloneDeep(viaPoints),
            'odRuleName': finalName
          }, 0);
        } else {
          // OD rule not found - clear to new OD state
          this.props.setFields(defaultFields, 0);
        }
      } else {
        // New OD rule or missing data - clear everything
        this.props.setFields(defaultFields, 0);
      }
    }
  }


  calculateRoute = () => {
    let { 
      request,
      selectedTab,
      paramsMapping,
      rawRequestWithAuth,
      getFieldsRequestOptions,
      isLoading
    } = this.props;
    const { apiUrl, postData } = this.state;
    if (!isLoading) {
      const cancelTokenSource = axios.CancelToken.source();
      this.setState({ cancelTokenSource });
      if (paramsMapping) {
        request(selectedTab, {
          cancelToken: cancelTokenSource.token,
          id: this.state.odId,
        });
      } else {
        let fieldsRequestOptions = getFieldsRequestOptions(selectedTab);

        const { formData, headers } = fieldsRequestOptions;
        let postFormData;
        // convert to form data if form is sent
        if (formData === true && postData) {
            const bodyFormData = new FormData();
            for (const [key, value] of Object.entries(postData)) {
              bodyFormData.append(key, value);
            }
            postFormData = bodyFormData;
        } else if (formData && postData) {
          postFormData = postData[formData];
        }
        
        rawRequestWithAuth(apiUrl, postFormData || postData, headers, selectedTab, {
          cancelToken: cancelTokenSource.token,
        });
      }
    } else if (this.state.cancelTokenSource) {
      this.state.cancelTokenSource.cancel();
    }
  }

  createNewOd = () => {
    const newOdId = uuidv4();
    this.setState({ 
      odId: newOdId, 
      isNewOdRule: true, 
      isChanged: false, 
      hasValidationErrors: true, 
      validationMessage: 'Required fields missing: origin, destination, rule name' 
    });
    this.props.setSelectedForm(newOdId);
    this.resetFields();
  }

  deleteCurrentOd = async () => {
    const { selectedCountry } = this.props;
    const { odId } = this.state;
        
    this.setState({ isSubmittingRules: true });
    
    try {
      const res = await deleteODCountryRules(selectedCountry, this.props.settings, odId);
      
      if(res.status === 'success' || res.status === 200 || res.status === 201 ){
        this.props.setSelectedForm(FORM_TYPES.GLOBAL);
        this.resetFields();
        this.props.setNotification({
          message: `OD rule for ${this.props.selectedCountry} deleted successfully.`,
          impact: 'positive',
          autoDismiss: 2,
        });
        await this.loadCountryRules();
      }
    } catch (error) {
      this.props.setNotification({
        message: `Failed to delete OD rule: ${error.message}`,
        impact: 'negative',
        autoDismiss: 5,
      });
    } finally {
      this.setState({ isSubmittingRules: false });
    }
  }

  render() {    
    const {
      isLeftPanelShown,
      selectedForm,
      paramsMapping,
      setTabParamsMapping,
      isResultPanelShown,
      isLoading,
      selectedCountry
    } = this.props;
    let inputConfigs = (!this.props.appSettings.isDevModeOn) 
      ? this.props.config[this.props.title].inputs
          .filter(input => (!input.isDevMode) ) 
        : this.props.config[this.props.title].inputs;
    
    inputConfigs = inputConfigs.filter(input => {
      if(input.onlyInCategory === true){
        if(selectedForm === FORM_TYPES.GLOBAL){
          return input.category && input.category.includes(FORM_TYPES.GLOBAL);
        } else {
          return input.category && input.category.includes(FORM_TYPES.OD);
        }
      }
      return true;
    });

    const { identicalInputsObj, categorizedArray } = !selectedCountry
      ? { identicalInputsObj: inputConfigs, categorizedArray: [] }
      : selectedForm === FORM_TYPES.GLOBAL ? segregateByCategory(inputConfigs, FORM_TYPES.GLOBAL)
      : segregateByCategory(inputConfigs, FORM_TYPES.OD);

    const rulesInputs = this.createInputs(categorizedArray);
    const calculateRouteInputs = this.createInputs(identicalInputsObj);

    const sidebarClasses = classnames('rf-filter-panel', {
      'rf-filter-panel_shown': isLeftPanelShown,
    });

    const btnClasses = classnames(
      'rf-filter-panel__toggler', {
        'rf-filter-panel_fadeout': !isLeftPanelShown,
      }
    );

    const isCountrySelected = selectedCountry && selectedCountry.length > 0;

    const ruleFormTitle = (selectedForm === FORM_TYPES.GLOBAL) 
      ? 'Global' 
      : (this.state.countryRules[selectedCountry]?.originDestinationRules &&
        this.state.odId in this.state.countryRules[selectedCountry].originDestinationRules
        ? this.state.countryRules[selectedCountry].originDestinationRules[this.state.odId].name +' OD' 
        :  'New OD');
  
    const canbeDeleted = selectedForm !== FORM_TYPES.GLOBAL 
      && this.state.countryRules[selectedCountry]?.originDestinationRules 
      && this.state.countryRules[selectedCountry]?.originDestinationRules[this.state.odId];

    const el = (
      <>
        <div className={btnClasses} onClick={this.toggleVisibility} />
        {!paramsMapping 
          && (
          <ParamsMapping
            paramsMapping={paramsMapping}
            setTabParamsMapping={setTabParamsMapping}
            isResultPanelShown={isResultPanelShown}
          />
        )}
        <Sidebar cssClasses={sidebarClasses}>
          <div className='rf-input-filters'>
            <CountryFilter setSearch={this.setCountry} setSelectedForm={this.setFormType} />

            {isCountrySelected && (
              <RulesFormDropdown
                onRuleFormChange={this.onRuleFormChange}
                selectedFormType={this.props.selectedForm}
                formTypeOptions={this.state.formTypeOptions}
              />
            )}
            {isCountrySelected && (
              <button className='rf-input-create-od-btn' onClick={this.createNewOd}>Create New OD Rule</button>
            )}
            <div className="rf-input-filters__divider" />
          </div>
          
          {this.state.isLoadingRules && (
            <div style={{ display: 'flex', justifyContent: 'center', padding: '20px' }}>
              <Loader />
            </div>
          )}


          {isCountrySelected
            && !this.state.isLoadingRules &&
            <RulesForm 
              canbeDeleted={canbeDeleted}
              inputs={rulesInputs} 
              submitCountryRules={this.submitCountryRules} 
              resetInputs={this.resetInputs} 
              isLoading={this.state.isSubmittingRules}
              formTitle={ruleFormTitle}
              activeUserInfo={this.props.activeUserInfo}
              selectedCountry={this.props.selectedCountry}
              handleDeleteOd={this.deleteCurrentOd}
              isFieldsChanged={this.state.isChanged}
              hasValidationErrors={this.state.hasValidationErrors}
              validationMessage={this.state.validationMessage}
              isNewOdRule={this.state.isNewOdRule}
            />
          }
          <div style={{ position: 'relative', paddingBottom: '46px' }}>
            {calculateRouteInputs}
          </div>
          
          <div className="bottom-btns-container">
            <button type='button' className="calculate-route-btn" onClick={this.calculateRoute}>
              {isLoading ? (
                <>
                  <lui-spinner />
                </>
              ) : (
                'Calculate Route'
              )}
            </button>
          </div>
        </Sidebar>
        
      </>
    );
    return el;
  }
}

FilterPanelContainer.propTypes = {
  title: PropTypes.string.isRequired,
  isLeftPanelShown: PropTypes.bool.isRequired,
  setIsLeftPanelShown: PropTypes.func.isRequired,
  setFields: PropTypes.func.isRequired,
  setNotification: PropTypes.func.isRequired,
  fields: PropTypes.object.isRequired,
  config: PropTypes.object.isRequired,
  settings: PropTypes.object.isRequired,
  tabId: PropTypes.number.isRequired,
  setResultState: PropTypes.func.isRequired,
  setSelectedForm: PropTypes.func.isRequired,
  setSelectedCountry: PropTypes.func.isRequired,
  selectedForm: PropTypes.string.isRequired,
  request: PropTypes.func.isRequired,
  setPreset: PropTypes.func.isRequired,
  setTabParamsMapping: PropTypes.func.isRequired,
  paramsMapping: PropTypes.bool.isRequired,
  isResultPanelShown: PropTypes.bool.isRequired,
  selectedCountry: PropTypes.string,
  isLoading: PropTypes.bool,
  getFieldsRequestOptions: PropTypes.func.isRequired,
  rawRequest: PropTypes.func.isRequired,
  rawRequestWithAuth: PropTypes.func.isRequired,
  appSettings: PropTypes.object.isRequired,
  activeUserInfo: PropTypes.object,
  setSupportedCountries: PropTypes.func.isRequired
};

function mapStateToProps(state) {
  return {
    title: getTitle(state),
    tabId: getID(state),
    isLeftPanelShown: getIsLeftPanelShown(state),
    fields: getFields(state),
    config: getConfig(state),
    settings: getTabSettings(state),
    paramsMapping: getTabParamsMapping(state),
    isResultPanelShown: getIsResultPanelShown(state),
    selectedForm: getSelectedForm(state),
    selectedCountry: getSelectedCountry(state),
    isLoading: getIsLoading(state),
    tabData: getSelectedTabs(state, SELECTEDTAB_INDEX),
    appSettings: getAppSettings(state),
    activeUserInfo: getActiveUserInfo(state),
    supportedCountries: getSupportedCountries(state)
  };
}

const mapDispatchToProps = {
  setIsLeftPanelShown,
  setFields,
  setNotification,
  setResultState,
  request: fetchData,
  setPreset,
  setTabParamsMapping,
  setSelectedForm,
  setSelectedCountry,
  getFieldsRequestOptions,
  rawRequest,
  rawRequestWithAuth,
  setRawResult,
  setSupportedCountries
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FilterPanelContainer);
